const EXTERNAL_SOURCES_CT_GOV_PROMPTS = [
  "Give me the list of trial locations of the clinical trials where Dr. [HCP Name] is involved?",
  "What are the recruitment metrics of study [topic name]?",
];

const EXTERNAL_SOURCES_PUBMED_PROMPTS = [
  "What is the comparative efficacy of currently available PAH drugs?",
  "Provide the details of research that Dr. [HCP Name] is involved in?",
];

const EXTERNAL_SOURCES_PROMPT_CATEGORIES = Object.freeze({
  "ct.gov": EXTERNAL_SOURCES_CT_GOV_PROMPTS,
  pubmed: EXTERNAL_SOURCES_PUBMED_PROMPTS,
});

export const EXTERNAL_SOURCES_CATEGORY_NAMES = Object.freeze(
  Object.keys(EXTERNAL_SOURCES_PROMPT_CATEGORIES)
);

// Static prompt data retained ONLY for the tool-mode starter tiles rendered in
// ChatContent (knowledge_bot / external_sources). The main Prompt Library
// (persona catalog + favourites) is backend-driven via GET /prompt-library, so
// only the per-role External Sources (ct.gov / pubmed) and Training Compass
// lists below are still read — see the helpers at the bottom of this file.
export const PromptDialogData = {
  SALESREP: {
    "ct.gov": EXTERNAL_SOURCES_CT_GOV_PROMPTS,
    pubmed: EXTERNAL_SOURCES_PUBMED_PROMPTS,

    "Training Compass": [
      "How do I log a call, and how long until it appears in Veeva CRM?",
    ],
  },
  RBD: {
    "ct.gov": EXTERNAL_SOURCES_CT_GOV_PROMPTS,
    pubmed: EXTERNAL_SOURCES_PUBMED_PROMPTS,

    "Training Compass": [
      "What data is currently available on RepAssist?",
    ],
  },
  LEADERSHIP: {
    "ct.gov": EXTERNAL_SOURCES_CT_GOV_PROMPTS,
    pubmed: EXTERNAL_SOURCES_PUBMED_PROMPTS,

    "Training Compass": [
      "How do I log a call in RepAssist?",
      "Can I use voice to text when logging a call?",
      "How long does it take for a logged call to appear in Veeva CRM?",
      "How do I prepare for an HCP call using RepAssist?",
      "Where can I find prebuilt prompts for call preparation?",
      "Can I review my previous call preparation notes before a meeting?",
      "How can RepAssist help me prepare for a QBR?",
      "Can RepAssist generate engagement strategies for my QBR?",
      "How do I identify high growth HCPs in my territory?",
      "What is RepAssist and what does it do?",
      "What is Synapse360?",
      "What kind of data does RepAssist bring together?",
      "I have a last-minute appointment with a KOL tomorrow. How can RepAssist help?",
      "My RBD is doing a ride along tomorrow and I need to prepare quickly. What should I do?",
      "It's Monday morning and I need to plan my week. How can RepAssist help an RBD?",
    ],
  },
};

export const TRAINING_COMPASS_CATEGORY = "Training Compass";
export const TRAINING_COMPASS_TOOL_ID = "knowledge_bot";
export const EXTERNAL_SOURCES_TOOL_ID = "external_sources";

export const TOOL_PROMPT_CATEGORY_GROUPS = {
  [TRAINING_COMPASS_TOOL_ID]: [TRAINING_COMPASS_CATEGORY],
  [EXTERNAL_SOURCES_TOOL_ID]: EXTERNAL_SOURCES_CATEGORY_NAMES,
};

export const ALL_TOOL_PROMPT_CATEGORIES = Object.freeze([
  TRAINING_COMPASS_CATEGORY,
  ...EXTERNAL_SOURCES_CATEGORY_NAMES,
]);

const getPromptsForToolCategory = (role, category, limit) => {
  const normalizedRole = (role || "SALESREP").trim().toUpperCase();
  const prompts = PromptDialogData[normalizedRole]?.[category] || [];
  return limit != null ? prompts.slice(0, limit) : prompts;
};

export const getTrainingCompassPromptsForRole = (role, limit) =>
  getPromptsForToolCategory(role, TRAINING_COMPASS_CATEGORY, limit);

export const getExternalSourcesPromptsForRole = (role, limit) => {
  const normalizedRole = (role || "SALESREP").trim().toUpperCase();
  const prompts = EXTERNAL_SOURCES_CATEGORY_NAMES.flatMap(
    (category) => PromptDialogData[normalizedRole]?.[category] || []
  );
  return limit != null ? prompts.slice(0, limit) : prompts;
};
